import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import StopIcon from 'modules/journey/Stop/StopIcon';
import StopComments from 'modules/journey/Stop/StopComments';
import TimeRange from 'components/TimeRange';
import StopExtras from 'modules/journey/Stop/StopExtras';
import moment from 'moment';
import { Spacer, Tag } from '@ontruck/orc';

import { StyledLabel, StyledSubLabel } from './styled';

const t = {
  diff_days: '{number, plural, one {+{number} day} other {+{number} days}}',
};

class StopInfo extends PureComponent {
  render() {
    const { stop, firstStopTimeFrom } = this.props;

    const firstTimeMoment = moment(firstStopTimeFrom).startOf('day');
    const stopTimeMoment = moment(stop.time_from).startOf('day');
    const diff = moment.duration(stopTimeMoment.diff(firstTimeMoment)).asDays();

    return (
      <Spacer mBottom="XS">
        <Fragment>
          <StyledLabel title={stop.address}>
            <StopIcon stop_type={stop.stop_type} /> {stop.address}
          </StyledLabel>
          <StyledSubLabel>
            <StopComments comments={stop.comments} mRight="XS" />
            <TimeRange from={stop.time_from} to={stop.time_to} />
            {!!diff && (
              <Spacer mLeft="XS">
                <Tag
                  text={
                    <FormattedMessage
                      id="diff_days"
                      defaultMessage={t.diff_days}
                      values={{
                        number: String(diff),
                      }}
                    />
                  }
                  size="S"
                  skin="dark"
                  textTransform="uppercase"
                />
              </Spacer>
            )}
            <Spacer mLeft="XS">
              <StopExtras {...stop} iconSize="18" />
            </Spacer>
          </StyledSubLabel>
        </Fragment>
      </Spacer>
    );
  }
}

StopInfo.propTypes = {
  stop: PropTypes.shape({
    stop_type: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    time_from: PropTypes.string.isRequired,
    time_to: PropTypes.string.isRequired,
    extras: PropTypes.array,
  }).isRequired,
  firstStopTimeFrom: PropTypes.string.isRequired,
};

export default StopInfo;
